import { render, staticRenderFns } from "./AddCoursePlan.vue?vue&type=template&id=9b0d4cb6&scoped=true"
import script from "./AddCoursePlan.vue?vue&type=script&lang=js"
export * from "./AddCoursePlan.vue?vue&type=script&lang=js"
import style0 from "./AddCoursePlan.vue?vue&type=style&index=0&id=9b0d4cb6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b0d4cb6",
  null
  
)

export default component.exports